import React, { FunctionComponent } from 'react';
import { Grid } from '@material-ui/core';
import SliderTitle from '../sliderTitle/SliderTitle';
import sliderTitleOfferStyles from './sliderTitleOfferStyles';
import PriceBadge from '../../../../presentational/priceBadge/PriceBadge';

interface ISliderTitleOffer {
  modelName: string;
  variantName: string;
  hasOffer: boolean;
  marketingLabel?: string;
  hasStock: boolean;
  driveawayPrice: number;
  distributionPrice: number;
  currency: string;
  decimalScale: number;
  stockLink?: {
    url: string;
    label: string;
  };
  isComplexModel: boolean;
  engine?: string;
  specPacks?: string;
}

const SliderTitleOffer: FunctionComponent<ISliderTitleOffer> = ({
  modelName,
  variantName,
  hasOffer,
  marketingLabel,
  hasStock,
  stockLink,
  driveawayPrice,
  distributionPrice,
  currency,
  decimalScale,
  isComplexModel,
  engine,
  specPacks,
}) => {
  const styles = sliderTitleOfferStyles();

  return (
    <Grid container={true} direction={'row'} className={styles.container}>
      <Grid item={true} sm={hasOffer ? 9 : 12} xs={hasOffer ? 6 : 12}>
        <SliderTitle
          modelName={modelName}
          variantName={variantName}
          centered={!hasOffer}
          hasStock={hasStock}
          stockLink={stockLink}
          marketingLabel={marketingLabel}
          isComplexModel={isComplexModel}
          engine={engine}
          specPacks={specPacks}
        />
      </Grid>
      {hasOffer && (
        <Grid item={true} sm={3} xs={6}>
          <PriceBadge
            distributionPrice={distributionPrice}
            driveawayPrice={driveawayPrice}
            currency={currency}
            decimalScale={decimalScale}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default SliderTitleOffer;
